import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Subject, Observable } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class MessageTemplateService {
  baseUrl: string = environment.API_SERVER;
  private refreshNotificationCount: Subject<any> = new Subject<any>();
  constructor(private _http: HttpClient) {}

  setRefreshNotification(chart): void {
    this.refreshNotificationCount.next(chart);
  }
  getRefreshNotification(): Observable<any> {
    return this.refreshNotificationCount.asObservable();
  }
  //load templates
  loadMessageTemplate(payload) {
    return this._http.get(this.baseUrl + '/admin/message_templates/', {
      params: payload.params,
    });
  }
  //load templates
  getMessageTemplate(payload) {
    return this._http.get(
      this.baseUrl + `/admin/message_templates/${payload.id}/`
    );
  }

  UpdateMessageTemplate(payload) {
    return this._http.put(
      `${this.baseUrl}/admin/message_templates/${payload.messageTemplateId}/`,
      payload.body
    );
  }

  addMessageTemplate(payload) {
    return this._http.post(
      `${this.baseUrl}/admin/message_templates/`,
      payload.body
    );
  }

  enableEmail(payload) {
    const url = `${this.baseUrl}/admin/message_templates/${payload.messageTemplateId}/email/`;
    return this._http.put(url, {}, { params: payload.params });
  }

  enableSms(payload) {
    const url = `${this.baseUrl}/admin/message_templates/${payload.messageTemplateId}/sms/`;
    return this._http.put(url, {}, { params: payload.params });
  }
}
